import find from 'lodash/find'
import { is } from 'ramda'
// Local
import {
  Property,
  TenantProperty
} from '../authenticated/types'

/** *****************************************************************************
 * Provides utilities for managing user properties
 */

export const findProperty = (
  properties: string | Property[] | TenantProperty[],
  key: string
): Property | undefined => {
  const props = properties || [] as any
  if (!is(String, properties)) {
    return find(props, p => p.propertyKey === key)
  }
  return undefined
}

export const hasProperty = (
  properties: Property[],
  key: string
): boolean => {
  const prop = findProperty(properties, key)
  return !!prop
}

export const propertyValue = (
  properties: string | Property[] | TenantProperty[],
  key: string
): string | null => {
  const prop = findProperty(properties, key)
  return prop ? prop.propertyValue : null
}
